import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { TimeEstimateForm } from "~/components/TimeEstimateForm/TimeEstimateForm.jsx";
import { fetchJobTypesAction } from "~/store/actions/actions.jobTypes";
import { editPersonalizedConfigOptions } from "~/store/actions/actions.personalizedConfigOptions";
import { getUserDefaultJobTypeId } from "~/store/selectors/selector.configOptions.jsx";
import { getActiveJobTypesArrayOfIdAndNameSelector, getJobTypeById } from "~/store/selectors/selector.jobTypes.jsx";

export const SelectTaskEstimate = ({ onChange, jobTypeId, ...rest }) => {
  const jobTypes = useSelector(getActiveJobTypesArrayOfIdAndNameSelector);
  const userDefaultJobType = useSelector(getUserDefaultJobTypeId);
  const jobType = useSelector((state) => getJobTypeById(state, jobTypeId));
  const dispatch = useDispatch();

  const handleChange = useCallback(
    ({ estimate, jobTypeId }) => {
      if (typeof onChange === "function") {
        onChange({ estimate, job_type_id: jobTypeId });
        if (jobTypeId !== userDefaultJobType && jobTypeId > 0) {
          dispatch(editPersonalizedConfigOptions({ default_job_type_id: jobTypeId }));
        }
      }
    },
    [dispatch, onChange, userDefaultJobType]
  );

  const jobTypesList = useMemo(() => {
    const list = jobTypes.findIndex((job) => job.id === jobTypeId) > -1 || !jobType ? jobTypes : [...jobTypes, jobType];
    return list.map(({ id, name }) => ({
      id,
      name,
    }));
  }, [jobType, jobTypeId, jobTypes]);

  useEffect(() => {
    dispatch(fetchJobTypesAction());
  }, [dispatch]);

  return (
    <TimeEstimateForm
      {...rest}
      jobTypeId={jobTypeId || userDefaultJobType}
      onSubmit={handleChange}
      jobTypesList={jobTypesList}
    />
  );
};

SelectTaskEstimate.propTypes = {
  onChange: PropTypes.func,
  jobTypeId: PropTypes.number,
};
